module.exports = __webpack_public_path__ + "img/icon-note.a5361072.svg";